<style lang="css">
.finance-account-search-box {
  position: absolute;
  right: 20px;
  top: 8px;
  height: 36px;
  overflow: hidden;
}
</style>
<template>
  <div class="sel-modal clearfix">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab">
        <ul class="tab-list">
          <li>
            <vxe-radio name="xtabs" label="tab1">结算账户列表</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <!-- <div class="finance-account-search-box">
        <vxe-input
          style="height: 34px !important; margin-right:5px"
          v-model="clientname"
          type="search"
          placeholder="搜索客户名称"
          @keyup.enter.native="search"
          @search-click="search"
          v-show="selectTab === 'tab2'"
        ></vxe-input>
        <vxe-input
          style="height: 34px !important"
          v-model="username"
          type="search"
          placeholder="搜索户名"
          @keyup.enter.native="search"
          @search-click="search"
        ></vxe-input>
      </div> -->
    </div>
    <div v-show="selectTab === 'tab1'">
      <vxe-table
        :loading="loading"
        show-overflow
        stripe
        highlight-current-row
        highlight-hover-row
        border="none"
        ref="xTable1"
        class="table-style"
        height="430"
        align="center"
        :auto-resize="true"
        :data="companyData"
        @current-change="currentChangeEvent1"
      >
        <vxe-table-column field="bindOpenBankName" title="开户银行"></vxe-table-column>
        <vxe-table-column field="bindAccNum" title="银行帐号"></vxe-table-column>
      </vxe-table>
      <!-- <vxe-pager
        background
        size="small"
        :current-page.sync="page1.currentPage"
        :page-size.sync="page1.pageSize"
        :total="page1.totalResult"
        @page-change="changePage1"
      ></vxe-pager> -->
    </div>
  </div>
</template>

<script>
import $api from "@/apiProvider";
import { apiRequest } from "@/utils/api";
import { isEmpty, isNotEmpty } from "@/utils/util";

export default {
  name: "Account",
  data() {
    return {
      loading: false,
      selectTab: "tab1",
      companyData: [],
      initObj: null,
      index: null,
      field: null,
    };
  },
  methods: {
    currentChangeEvent1({ row }) {
      this.$emit("choose", row, this.index, this.field);
    },
    search() {
      if (this.selectTab === "tab1") {
        this.queryCompUserList();
      } 
    },
    init(obj, i) {
      this.selectTab = "tab1";
      this.initObj = obj;
      this.index = i;
      this.queryCompUserList();
    },
    async queryCompUserList() {
        
      this.loading = true;
      let path = "api/finance/";
      let action = "cebBusiMem/queryBindAccount";
      let subAcc = isNotEmpty(this.initObj.recAccount) ? this.initObj.recAccount : null;
      let params = {
        subAcc,
      };
      let res = await apiRequest(path, action, params);
      this.loading = false;
      if (res.status === 1) {
        this.companyData = res.data;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    close() {
      this.selectTab = "tab1";
      this.$refs.xTable1.clearCurrentRow();
    },
  },
};
</script>

<style>
</style>